import { render, staticRenderFns } from "./basetable2.vue?vue&type=template&id=2b183ee0"
import script from "./basetable2.vue?vue&type=script&lang=js"
export * from "./basetable2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports